import { Injectable } from '@angular/core';
import { oneSignalAppId } from '../config';
import { Storage } from '@ionic/storage';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
// import { OneSignal } from '@ionic-native/onesignal/ngx';
import { HandleNotificationService } from './handle-notification';
import { Platform } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { UpdateModalPage } from '../pages/update-modal/update-modal';
import { isDefined } from 'ionic-angular/umd/util/util';
import { ToastProvider } from '../providers/toast/toast';
import { stringify } from '@angular/core/src/util';
import OneSignal from 'onesignal-cordova-plugin';

@Injectable()
export class MobileAppService {
  URL = environment.ismUrl;
  isAndroid = false;
  constructor(private http: HttpClient, 
    private storage: Storage,
    private handler: HandleNotificationService,
    public platform: Platform,
    private modalCtrl: ModalController,
    public toast: ToastProvider
    ) {
      this.isAndroid = this.platform.is('android');
  }
  static islogout = 0;

  
  stopVisitSound(){
    if(window["plugins"] && window["plugins"].hello){
      var hello = window["plugins"].hello
      // setTimeout(() => {
        hello.greet("stop-visit-sount", (message)=>{console.log("Success message: ", message)}, 
        (message)=>{console.log("Error message: ", message)});
      // }, 500);
    }else{
      if(environment.debug) console.log("ISM hello plugin not found: ", hello);
    }
  }

  initOneSignal(){
    // window["plugins"].OneSignal.setLogLevel({logLevel: 6, visualLevel: 4});

    var notificationOpenedCallback = (data) => {
      if(environment.debug) console.log('Enter notificationOpenedCallback(data):- ', data);
      this.handler.handleNotifications(data);
      this.stopVisitSound()
    };

    var handleNotificationReceivedCallback = (data) => {
      let d = {notification : data};
      if(environment.debug) console.log('Enter handleNotificationReceivedCallback(data):- ', data);
      this.handler.handleNotifications(d); 
      this.stopVisitSound()
    }
    try{
      console.log(OneSignal,window["plugins"],'onensingla-----' );
        OneSignal.setAppId(environment.oneSignalAppId);
        // .startInit(environment.oneSignalAppId,environment.oneSignalGoogleId)
        // .handleNotificationOpened(notificationOpenedCallback)
        // .inFocusDisplaying(window["plugins"].OneSignal.OSInFocusDisplayOption.None)
        // .handleNotificationReceived(handleNotificationReceivedCallback)
        // .endInit();
        OneSignal.setNotificationWillShowInForegroundHandler(handleNotificationReceivedCallback );
        OneSignal.setNotificationOpenedHandler(notificationOpenedCallback);
        // OneSignal.id(notificationOpenedCallback);
    
      // Prompts the user for notification permissions.
      //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
      OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
          console.log("User accepted notifications: " + accepted);
      });
    
      /** Display device id */
      window["plugins"].OneSignal.getDeviceState(deviceData => {
        if(environment.debug) console.log("Device data ---------------",deviceData);
      });
    }catch(e){
      console.error("Error in MobileAppService->initOneSignal() =>", e)
    }
// Getting intent when activity is open
    // window["plugins"].intent.setNewIntentHandler( (intent) => {
    //   console.log("hohohohohohooohoh")
    //     console.log(intent)
    // });
  }


  getIntent(successCallback, errorCallback){
    try{
      return window["plugins"].intent.getCordovaIntent(successCallback, errorCallback);
    }catch(e){
      console.error( e)
      throw e;
    } 
  }

  openApp(appObj, extras){//   { "android" : "", "ios": "","err_android": "","err_ios": "","name": "","disp_name":"","enabled":,}
    try{
      let packageName = this.isAndroid ? appObj.android : appObj.ios;//com.e.xeniusapp
      //let extras = [{"name":"token_id",	"value":"ABC12345","dataType":"String"}]
      window["plugins"].launcher.canLaunch({packageName: packageName, extras:extras},
        data => {
          this.toast.presentToast('Opening ...'+appObj.name)
          window["plugins"].launcher.launch({packageName: packageName,extras:extras},
            data=>console.log('launched##'),
            err=> this.openErrApp(appObj)
          );
        },
        err=> this.openErrApp(appObj)
      );
    }catch(e){
      this.toast.presentToast("Oops! Something went wrong.");
    }
  }
  openErrApp(appObj){
    console.info('Opening App store for '+appObj.err_android);
    let errPkg = this.isAndroid ? appObj.err_android : appObj.err_ios;
    this.toast.presentToast(appObj.name+ " not installed. Launching App store");
    window["plugins"].launcher.launch(errPkg,d=>console.log("App store launched."),e=>console.error(e));
  }
  registerApp(){
    console.log("Enter registerApp ==>");
    this.getToken().then((val) => {
      console.log("registerApp got token ==>", val);
      if(val){
        // if(environment.debug==1) console.log("Before one signal plugin called ==>",val);        
        return window["plugins"].OneSignal.getDeviceState(deviceData => {
          return this.http.post<Response>(this.getUrl(`/appRegistered`,val), {
            app_name: environment.oneSignalAppName,
            app_version_code: environment.AppVersionCode,
            app_device_id : deviceData.userId,
            userId: deviceData.userId,
            tenant: !val.tenant || val.tenant == 0 || typeof val.tenant === 'undefined' || val.tenant == 'undefined' || val.tenant == false ? 0 : 1
          })
          .toPromise();
        });
      }
    }).then(val => {
      console.log("app registered");
    }).catch(val => {
      console.log("registration failed"+val);
    });
  }
  registerAppToToken(id, societyId, token){
    try{
      return window["plugins"].OneSignal.getDeviceState(deviceData => {
        return this.http.post<Response>(`${this.URL}/registerapp?token=${token}&id=${id}&society_id=${societyId}`, {
          app_data:{
            app_name: environment.oneSignalAppName,
            app_version_code: environment.AppVersionCode,
            app_device_id : deviceData.userId,
            userId: deviceData.userId,
        }})
        .toPromise();
      })
    }catch(e){
      console.error(e);
      
    }
  }

  unRegisteredApp(){
    this.getToken().then((val) => {
      if(val){
        return window["plugins"].OneSignal.getDeviceState(deviceData => {
          return this.http.post<Response>(this.getUrl(`/appUnRegistered`,val), {
            userId: deviceData.userId,
            tenant: !val.tenant || val.tenant == 0 || typeof val.tenant === 'undefined' || val.tenant == 'undefined' || val.tenant == false ? 0 : 1
          })
          .toPromise();
        });
      }
    }).then(val => {
      console.log("app unregistered");
    }).catch(val => {
      console.log("unregistration failed"+val);
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(link: string, val: any):string {
    return (this.URL+link +'?api-token='+val.api_token+'&user-id='+val.id);
  }

  checkAppUpdate(){
    
    try{
     
      var appCode = (typeof environment.appName !== 'undefined' && environment.appName) ? environment.appName : ''
      var currentVersionCode =  environment.AppVersionCode
           var url = `/appversion?code=${appCode}&version_code=${currentVersionCode}`;
      this.getToken().then((val) => {
       
        if(val){
          this.http.get<any>(this.getUrl(url,val)).toPromise().then(val => {
             if(val && val.status == "error"){
                console.log("successes for update")
                let profileModal = this.modalCtrl.create(UpdateModalPage,{
                  message: val.message,
                  title: 'Update Available'
                })
                profileModal.present();
             }
          })
        }
      })
    }catch(e){
      console.log(e)
    }
  }
  switchToWeb(){
    this.handler.switchToWeb();
  }
}

// {
// 	"action": {
// 		"type": 0
// 	},
// 	"notification": {
// 		"isAppInFocus": false,
// 		"shown": true,
// 		"androidNotificationId": 2049084178,
// 		"displayType": 0,
// 		"payload": {
// 			"notificationID": "d6b0e6f8-ab83-4ba5-a7d2-ec12d13935be",
// 			"body": "Nishkarsh (8982625660) is asking you to allow for visit for Guest",
// 			"additionalData": {
// 				"view": "notification-details",
// 				"data": {
// 					"id": 378980,
// 					"type": "VISIT"
// 				}
// 			},
// 			"lockScreenVisibility": 1,
// 			"fromProjectNumber": "53760756113",
// 			"priority": 0,
// 			"rawPayload": "{\"google.delivered_priority\":\"normal\",\"google.sent_time\":1551878964993,\"google.ttl\":259200,\"google.original_priority\":\"normal\",\"custom\":\"{\\\"a\\\":{\\\"view\\\":\\\"notification-details\\\",\\\"data\\\":{\\\"id\\\":378980,\\\"type\\\":\\\"VISIT\\\"}},\\\"i\\\":\\\"d6b0e6f8-ab83-4ba5-a7d2-ec12d13935be\\\"}\",\"from\":\"53760756113\",\"alert\":\"Nishkarsh (8982625660) is asking you to allow for visit for Guest\",\"google.message_id\":\"0:1551878965002831%13a4e080f9fd7ecd\",\"notificationId\":2049084178}"
// 		}
// 	}
// }



// WEBPACK FOOTER //
// ./src/services/mobile-app.ts